import type { TranslateFn, UploadFileRejection } from 'src/lib/pricelist-utils';

/** Supplier workbooks: `.xlsx`, or classic `.xls`. */
export const RESULTS_ACCEPT =
  '.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function validateResultsFile(
  file: File,
  gt: TranslateFn,
): UploadFileRejection | null {
  if (/\.(xlsx|xls)$/i.test(file.name)) return null;
  return {
    kind: 'unsupported',
    title: gt('Unsupported file format', {
      context:
        'toast title when a non-Excel file is dropped on Results → Upload',
    }),
    message: gt('Please upload the supplier results workbook (.xlsx).', {
      context:
        'toast message when a non-Excel file is dropped on Results → Upload',
    }),
  };
}
